class AccountSettings.ExportableFieldsListView extends Backbone.View
  template: JST["backbone/templates/account_settings/exportable_fields/list"]
  createdField: JST["backbone/templates/account_settings/exportable_fields/created_field"]

  events:
    'click .exportable-fields-list span#name': 'selectField'
    'click .exportable-fields-list input[type=checkbox]': 'selectField'
    'click .exportable-fields-list #update': 'onUpdate'

  allSectionNames: ->
    [
      'content',
      'keepcon',
      'profile',
      'custom',
      'facebook',
      'twitter',
      'email',
      'news',
      'content_custom',
      'google_my_business',
      'google_play',
      'apple_store'
    ]

  render: =>
    @selectedFields = {}
    _.each(@allSectionNames(), (sectionName) =>
      @selectedFields[sectionName] = []
    )
    @allFields = {}
    @_loadAndRenderFields()
    @

  _loadAndRenderFields: =>
    $.get('/exportable_fields', (response) =>
      _.each(@allSectionNames(), (sectionName) =>
        @selectedFields[sectionName] = response[sectionName]
      )

      $.get('/exportable_fields/complete_list', (response) =>
        @allFields = response
        @$el.html(@template(@))
        @renderList()
      )
    )

  renderList: ->
    _.each(@allSectionNames(), (sectionName) =>
      sectionClassName = sectionName.replaceAll('_', '-')
      @_createListFor(sectionName, @$el.find(".exportable-fields-list ##{sectionClassName}"))
    )

  _createListFor: (key, listDOM) ->
    return if _.isEmpty(@allFields[key])
    nonSelected = _.reject(@allFields[key], (field) => _.contains(@selectedFields[key], field))
    sortedList = @selectedFields[key].concat(nonSelected)

    _.each(sortedList, (field) =>
      if "#{key}" == "content_custom"
        name = "#{field.split('-SEPARATOR-').pop()}"
      else if "#{key}" == "custom"
        name = "#{field}"
      else if "#{key}" == "news"
        name = "#{field}".split(".")[1]
        name = I18n.t("monitoring.exportable_fields.#{key}."+name)
      else if "#{key}" == "email"
        name = "#{field}".split(".")[1]
        name = I18n.t("monitoring.exportable_fields.#{key}."+name)
      else if "#{key}" == 'google_my_business'
        fields = field.split('.')
        fields.shift()
        translation_field = fields.join('.')
        name = I18n.t("monitoring.exportable_fields.#{key}.#{translation_field}")
      else
        name = I18n.t("monitoring.exportable_fields.#{key}.#{field}")

      listDOM.append(@createdField(
        id: field
        group: key
        name: name
        selected: if _.contains(@selectedFields[key], field) then 'checked' else ''
      ))
      listDOM.sortable({
        axis: "y", cursor: "move", containment: @$el.find(".exportable-fields-list ##{key}"), stop: ((event) =>
          @_saveSortedList(key, listDOM))
      })
    )

  _saveSortedList: (key, listDOM) =>
    sortedList = _.select(listDOM.children(), (element) ->
      $(element).find('#selected').prop('checked')
    )
    @selectedFields[key] = _.collect(sortedList, (field) -> field.id)

  selectField: (event) ->
    element = $(event.target).parent()[0]
    key = element.dataset.group
    if _.include(@selectedFields[key], element.id)
      index = @selectedFields[key].indexOf(element.id)
      @selectedFields[key].splice(index, 1)
      $(element).find('#selected').prop('checked', false)
    else
      @selectedFields[key] ||= []
      @selectedFields[key].push(element.id)
      $(element).find('#selected').prop('checked', true)

  onUpdate: (event) ->
    event.preventDefault()
    data = { fields_by_sections: @selectedFields }
    $.post('/exportable_fields/update', data, (response) =>
      if response.success
        noty({text: I18n.t('monitoring.exportable_fields.messages.success'), type: 'notice'})
      else
        window.showError(I18n.t('monitoring.exportable_fields.messages.error'))
    )
